var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',_vm._g(_vm._b({staticClass:"custom-dropdown",class:{ dark: _vm.dark },attrs:{"show-labels":false,"tag-placeholder":"+"},scopedSlots:_vm._u([{key:"noOptions",fn:function(){return [_vm._v("Aucun élément trouvé")]},proxy:true}])},'multiselect',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }